import { useTheme } from "@mui/system";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const BalootPieChart = ({ data }) => {
  const theme = useTheme();
  const COLORS = Array.apply(null, Array(10)).map(function (_, index) {
    return theme.palette.chart[index].main;
  });
  return (
    <ResponsiveContainer width={140} height={140}>
      <PieChart margin={{ top: 16, right: 16, left: 16, bottom: 16 }}>
        <text
          x={70}
          y={70}
          textAnchor="middle"
          dominantBaseline="middle"
          style={{ fontSize: 14, fontWeight: "bold" }}
        >
          دارایی ها
        </text>
        <Pie
          startAngle={360}
          endAngle={0}
          innerRadius={60}
          data={data}
          labelLine={false}
          outerRadius={70}
          dataKey="percentage"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default BalootPieChart;
